"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushToTalkButton = void 0;
var react_1 = __importStar(require("react"));
var react_client_1 = require("@speechly/react-client");
var pubsub_js_1 = __importDefault(require("pubsub-js"));
var types_1 = require("../types");
var HintCallout_1 = require("./HintCallout");
require("@speechly/browser-ui/holdable-button");
var PushToTalkButton = function (_a) {
    var captureKey = _a.captureKey, _b = _a.size, size = _b === void 0 ? '6.0rem' : _b, _c = _a.gradientStops, gradientStops = _c === void 0 ? ['#15e8b5', '#4fa1f9'] : _c;
    var _d = react_client_1.useSpeechContext(), speechState = _d.speechState, toggleRecording = _d.toggleRecording, initialise = _d.initialise;
    var _e = react_1.useState(react_client_1.SpeechState.Idle), icon = _e[0], setIcon = _e[1];
    var buttonRef = react_1.useRef();
    var speechStateRef = react_1.useRef();
    // make stateRef always have the current count
    // your "fixed" callbacks can refer to this object whenever
    // they need the current value.  Note: the callbacks will not
    // be reactive - they will not re-run the instant state changes,
    // but they *will* see the current value whenever they do run
    speechStateRef.current = speechState;
    react_1.useEffect(function () {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) {
            var button = buttonRef.current;
            button.onholdstart = tangentPressAction;
            button.onholdend = tangentReleaseAction;
        }
    });
    // Change button face according to Speechly states
    react_1.useEffect(function () {
        setIcon(speechState);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [speechState]);
    var tangentPressAction = function () {
        pubsub_js_1.default.publish(types_1.SpeechlyUiEvents.TangentPress, { state: speechStateRef.current });
        switch (speechStateRef.current) {
            case react_client_1.SpeechState.Idle:
            case react_client_1.SpeechState.Failed:
                // Speechly & Mic initialise needs to be in a function triggered by event handler
                // otherwise it won't work reliably on Safari iOS as of 11/2020
                initialise().catch(function (err) { return console.error('Error initiasing Speechly', err); });
                break;
            case react_client_1.SpeechState.Ready:
                toggleRecording().catch(function (err) { return console.error('Error while starting to record', err); });
                break;
            default:
                break;
        }
    };
    var tangentReleaseAction = function (e) {
        pubsub_js_1.default.publish(types_1.SpeechlyUiEvents.TangentRelease, { state: speechStateRef.current, timeMs: e.timeMs });
        switch (speechStateRef.current) {
            case react_client_1.SpeechState.Recording:
                toggleRecording().catch(function (err) { return console.error('Error while stopping recording', err); });
                break;
            default:
                break;
        }
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("holdable-button", { ref: buttonRef, capturekey: captureKey, icon: icon, size: size, gradientstop1: gradientStops[0], gradientstop2: gradientStops[1] }),
        react_1.default.createElement(HintCallout_1.HintCallout, null)));
};
exports.PushToTalkButton = PushToTalkButton;
//# sourceMappingURL=PushToTalkButton.js.map